// extracted by mini-css-extract-plugin
export default {"itemName":"S_sfYQjPIpSEFZJ7gRcg"};